// Externals
import type { Reducer } from 'redux';

// Actions
import { Actions } from '../actionTypes/actionTypes';
import { getShowroomNavInitialState } from './initialState';
import type { ShowroomNavState } from './types';

/**
 * Reducer for the Showroom nav slice.
 *
 * Owns the dealer logo and the left-nav drawer flag. Runtime data is read at the
 * hook layer from its source slice — buyer/co-buyer names from `customer`, the
 * recent-deals badge count from the `customerVehicles` activity slice.
 */
export const showroomNav: Reducer<ShowroomNavState> = (state = { ...getShowroomNavInitialState() }, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case Actions.SET_DEALER_LOGO: {
            return {
                ...state,
                logoConfig: {
                    logoURL: payload.logoURL || ''
                }
            };
        }
        case Actions.SET_SHOWROOM_LEFT_NAV_OPEN: {
            return {
                ...state,
                isLeftNavOpen: !!payload
            };
        }
        case Actions.SET_HAMBURGER_VISIBILITY: {
            return {
                ...state,
                isHamburgerVisible: !!payload
            };
        }
        case Actions.SET_ACTIVE_SECTION: {
            return {
                ...state,
                activeSectionKey: payload
            };
        }
        case Actions.ACTIVATE_SECTION: {
            const { sectionKey } = payload;

            return {
                ...state,
                activeSectionKey: sectionKey,
                sectionScrollRequest: { sectionKey, id: (state.sectionScrollRequest?.id ?? 0) + 1 }
            };
        }
        default: {
            return state;
        }
    }
};
